/**
 * Announces a screen to GTM in the shape GA4 can report on.
 *
 * GA4's own page view is unusable for us: the path carries record ids, so every
 * vehicle is its own row, and the title is translated, so one screen is counted
 * once per language. `page_route` and `page_section` are free of both.
 *
 * GTM maps them onto the GA4 page view and registers them as event-scoped
 * dimensions; until that exists the values sit in the dataLayer, where preview
 * mode can read them.
 */
interface GtmPageViewContext {
  app: string;
  module: string;
  product: string;
}

export function pushGtmPageView(
  pageRoute: string,
  pageSection: string,
  context: GtmPageViewContext
) {
  const dataLayer = {
    event: 'page_view_normalized',
    app: context.app,
    page_module: context.module,
    page_route: pageRoute,
    page_section: pageSection,
    product: context.product,
  };

  if (window && window.dataLayer) {
    window.dataLayer.push(dataLayer);
  }
}
